<template>
  <div class="page">
    <img :src="`${cdnresources}/prod/images/yueyangbao/cjwt.png`"/>
    <div class="page-content">
      <div v-for="(item,index) in datalist" :key="index">
        <div class="page-question">
           <img src="@/assets/img/insu_detail/cjwt-01.png" alt="">
           <span class="question-head">{{item.question}}</span>
        </div>
        <div class="page-answer">
           <img src="@/assets/img/insu_detail/cjwt-02.png" alt="">
           <!-- <span class="answer-head">{{item.answer}}</span> -->
           <div class="answer-head">
             <span v-for="(a, index) in item.answer.split('#')" :key="index">{{a}}<br/></span>
           </div>
            
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { cdnresources } from '@/util/config'
import { homepageresources } from '@/api/company-appointment'
import { InsuFaqQusetionsArray } from '@/util/insu-faq-questions'

export default {
  name: 'Faq',
  filters: {},
  components: {
  },
  mixins: [],
  props: {},
  data() {
    return {
      cdnresources,
      datalist:[]
    }
  },
  computed: {},
  watch: {},
  beforeCreate() { },
  created() { },
  beforeMount() { },
  async mounted() { 
    const res = await homepageresources()
    this.datalist = InsuFaqQusetionsArray(res.goodsExt.CJWTALL)
    console.log(res.goodsExt.CJWTALL)
    console.log(this.datalist)

  },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  methods: {}
}
</script>
<style lang="scss" scoped>
.page{
  display: flex;
  flex-direction: column;
  background-color: #f6f6f6;
  img{
    width: 100%;
  }
  .page-content {
    margin: xvw(40) auto;
    width: 90%;
    padding: xvw(40) xvw(40) 0;
    background: #ffffff;
    border-radius: xvw(30);
    box-shadow: 0px 5px 12px 0px rgba(254, 90, 82, 0.15);
    img {
      width: xvw(44);
      height: xvw(40);
      margin-right: xvw(20);
    }
  .page-question {
     display: flex;
     margin-bottom: xvw(20);
    .question-head {
      font-size: px2rem(18, 375);
      font-weight: 500;
      color: #333333;
      line-height: 18px;
    }
  }
    .page-answer {
       display: flex;
       margin-bottom: xvw(40);
      .answer-head {
        text-align: justify;
        color: #333333;
        font-size: px2rem(15, 375);
        background: #FFF6F6;
        padding: xvw(20);
        border-radius: xvw(20);
        line-height: xvw(40);
      }
    }
  }
}
</style>
